/*
 * @Description: 新闻报道
 */

import { useState, useEffect } from "react";
import { getdataLists } from "../../../api/home";
import {Pagination, Tabs} from "antd";
import TextImg from "../../../components/TextImg";

import "./index.less";

// 新闻报道列表
const items = [
  {
    id: '19',
    label: '优秀学子及人才培养',
  },
  {
    id: '20',
    label: '困境未成年人帮扶',
  },
  {
    id: '21',
    label: '应急救灾/助困帮扶',
  },
  {
    id: '22',
    label: '公益基金会资讯',
  }
];

// 切页
function itemRender(current, type, originalElement) {
  if (type === "prev") {
    return <span style={{marginRight: '10px'}}>上一页</span>;
  }
  if (type === "next") {
    return <span style={{marginLeft: '10px'}}>下一页</span>;
  }
  return originalElement;
}
const useDynamic = (page,id) => {
  const [dynamic, setDynamic] = useState({ list: [], pageInfo: {} });
  useEffect(() => {
    // 获取公告数据
    getdataLists({page:page,location_id:id}).then((res) => {
      const { code, data } = res;
      if (code === 200) setDynamic(data);
    });
  }, [page,id]);
  return [dynamic];
};

const FoundationNewsReport = () => {
  // 选中项

  const [page,setPage] = useState(1);
  const [locationId,setLocationId] = useState(19)

  const [dynamic] = useDynamic(page,locationId);
  // change tab Pane
  let changeTabPane = (val) => {
    setPage(1)
    setLocationId(val)
  }

  return (
    <div className="foundation-project w1200">
      <div className="welfare-dt">
        <div>
          <Tabs 
            defaultActiveKey="19" 
            type="card" 
            onChange={changeTabPane}
            items={items.map((item) => ({
              key: item.id,
              label: item.label,
              children: (
                <div className="welfart-dt-content">
                  {dynamic.list.map((dy, dyi) => {
                    return (
                      <TextImg {...dy} meta='公益动态' pathname="/project" key={dyi}/>
                    );
                  })}
                  <Pagination
                    total={dynamic.pageInfo.dataTotal}
                    itemRender={itemRender}
                    pageSize={8}
                    current={dynamic.pageInfo.current}
                    showSizeChanger={false}
                    onChange={(page, pageSize) => {
                      setPage(page);
                    }}
                  />
                </div>
              ),
            }))}
          />
        </div>

      </div>
    </div>
  );
};

export default FoundationNewsReport;
